import { Home, Search, AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { ROUTES } from '../constants';
import { LayoutWrapper } from '../components/LayoutWrapper';

export function NotFound() {
  return (
    <LayoutWrapper>
      <div className='flex-grow flex items-center justify-center'>
        <div className='container mx-auto px-4 py-16 text-center'>
          <div className='mb-8'>
            <AlertCircle className='w-20 h-20 text-blue-600 mx-auto mb-6' />
            <h1 className='text-6xl font-bold text-gray-900 mb-4'>
              <FormattedMessage id='404.title' defaultMessage='404' />
            </h1>
            <h2 className='text-2xl font-semibold text-gray-700 mb-4'>
              <FormattedMessage
                id='404.subtitle'
                defaultMessage='Страница не найдена'
              />
            </h2>
            <p className='text-gray-600 max-w-md mx-auto mb-8'>
              <FormattedMessage
                id='404.description'
                defaultMessage='Страница, которую вы ищете, могла быть удалена или её URL изменился. Попробуйте использовать поиск или вернуться на главную страницу.'
              />
            </p>
          </div>

          <div className='flex flex-col sm:flex-row justify-center items-center gap-4'>
            <Link
              to='/'
              className='inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors'
            >
              <Home className='w-5 h-5 mr-2' />
              <FormattedMessage id='404.home' defaultMessage='На главную' />
            </Link>
            <Link
              to={ROUTES.services}
              className='inline-flex items-center px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors'
            >
              <Search className='w-5 h-5 mr-2' />
              <FormattedMessage
                id='404.search'
                defaultMessage='Искать услуги'
              />
            </Link>
          </div>

          <div className='mt-12'>
            <h3 className='text-lg font-semibold text-gray-700 mb-4'>
              <FormattedMessage
                id='404.suggestions'
                defaultMessage='Возможно, вам будет интересно:'
              />
            </h3>
            <div className='flex flex-wrap justify-center gap-4'>
              <Link
                to={ROUTES.services}
                className='text-blue-600 hover:text-blue-700'
              >
                <FormattedMessage
                  id='404.allServices'
                  defaultMessage='Все услуги'
                />
              </Link>
              <Link
                to={ROUTES.addService}
                className='text-blue-600 hover:text-blue-700'
              >
                <FormattedMessage
                  id='404.postService'
                  defaultMessage='Добавить услугу'
                />
              </Link>
              <Link
                to={ROUTES.faq}
                className='text-blue-600 hover:text-blue-700'
              >
                <FormattedMessage id='404.faq' defaultMessage='FAQ' />
              </Link>
              <Link
                to={ROUTES.contact}
                className='text-blue-600 hover:text-blue-700'
              >
                <FormattedMessage
                  id='404.contact'
                  defaultMessage='Связаться с нами'
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </LayoutWrapper>
  );
}
